// Module 2 / Slice 9 — codes under a code-set.
// Plan §10 screen 1 (codes sub-view). Read-only list for v1.

import { useQuery } from "@tanstack/react-query";
import { referenceApiClient } from "../../api/client";
import { useI18n } from "../../i18n/I18nContext";
import { useParams, Link } from "@tanstack/react-router";

export function CodeIndexScreen(): JSX.Element {
  const { t } = useI18n();
  const { codeSetId } = useParams({ from: "/authed/admin/reference/code-sets/$codeSetId/codes" });
  const query = useQuery({
    queryKey: ["reference", "codes", codeSetId],
    queryFn: async () => {
      const response = await referenceApiClient.GET(
        "/reference/code-sets/{codeSetId}/codes",
        {
          params: {
            path: { codeSetId },
            query: { limit: 200, includeArchived: true },
          },
        },
      );
      if (!response.data) {
        throw new Error("reference_codes_fetch_failed");
      }
      return response.data;
    },
  });

  return (
    <div>
      <p>
        <Link to="/admin/reference/code-sets">{t("reference.codes.back")}</Link>
      </p>
      <h1>{t("reference.codes.heading")}</h1>
      {query.isLoading && <p>{t("login.discovering")}</p>}
      {query.isError && (
        <p role="alert" style={{ color: "var(--rc-color-danger)" }}>
          {(query.error as Error).message}
        </p>
      )}
      {query.data && query.data.items && query.data.items.length === 0 && (
        <p>{t("reference.codes.empty")}</p>
      )}
      {query.data && query.data.items && query.data.items.length > 0 && (
        <table className="rc-table">
          <thead>
            <tr>
              <th>{t("reference.codes.column.code")}</th>
              <th>{t("reference.codes.column.label")}</th>
              <th>{t("reference.codes.column.kind")}</th>
              <th>{t("reference.codes.column.sortOrder")}</th>
              <th>{t("reference.codes.column.active")}</th>
            </tr>
          </thead>
          <tbody>
            {query.data.items.map((c) => (
              <tr key={c.id}>
                <td><code>{c.code}</code></td>
                <td>{c.label}</td>
                <td>{c.kind ?? "\u2014"}</td>
                <td>{c.sortOrder}</td>
                <td>{c.isActive ? "\u2714" : "\u2014"}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}
